import React, { useState, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import Select from 'react-select';
import API from "../../config/api";

const QuestionsNew = () => {
  const [state, setState] = useState({
    title_kh: "",
    title_en: "",
    title_ch: "",
    description_kh: "",
    description_en: "",
    description_ch: "",
    release_date: "",
    total_price: "",
    discount: "",
    thumbnail_url: "",
    preview_video_url: "",
    rating: "",
    total_rating: "",
    options: [],

    selected_tag_id: [],

    success: null,
    error: null,
    tags: [],
    percentage: 0,
    disable: true,

    imageUrl: 'https://img.freepik.com/free-photo/side-view-ofserious-man_23-2148946213.jpg?size=626&ext=jpg&ga=GA1.1.1518270500.1717372800&semt=ais_user',
    numChildren: 0
  });

  useEffect(() => {
    getAllCategories();
  }, []);

  const getAllCategories = async () => {
    try {
      let query = `page=${1}`
      let results = await API.getAllCategory(query);
      let data = results.data;

      setState(prev => ({ ...prev, tags: data.videos })); // Original code used data.videos, suspicious if it was category API

    } catch (error) {
      console.log(error)
    }
  }

  const onChangeFile = async (event) => {
    event.preventDefault();
    let file = event.target.files[0];
    const formData = new FormData();
    formData.append("file", file);

    try {
      let results = await API.adminUpload(
        formData,
        onUploadProgress
      );

      if (results) {
        setState(prev => ({ ...prev, thumbnail_url: results.filename }));
      }

    } catch (error) {
      console.log(error)
    }
  }

  const handleInput = (event) => {
    event.preventDefault();
    let value = event.target.value;
    let name = event.target.name;

    setState(prev => ({ ...prev, [name]: value }));
  }

  const onUploadProgress = (percentage) => {
    setState(prev => ({ ...prev, percentage: percentage }));
    if (percentage === 100) {
      setState(prev => ({ ...prev, disable: false }));
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log(state.title_en, state.title_kh, state.description_kh, state.description_en, state.total_price, state.discount,
      state.release_date, state.rating, state.total_rating, state.thumbnail_url, "fdsajdfusuds8uusdjjsjjsjsjj"
    )
    let data = {
      "name_kh": state.title_kh,
      "name_en": state.title_en,
      "name_ch": "",
      "description_kh": state.description_kh,
      "description_en": state.description_en,
      "description_ch": state.description_ch,
      "total_price": state.total_price,
      "discount": state.discount,
      "option": state.options,
      "release_date": state.release_date,
      "rating": state.rating,
      "total_rating": state.total_rating,
      "thumbnail_url": state.thumbnail_url,
      "tags": JSON.stringify(state.selected_tag_id),
    };

    console.log(data)
    // Code dealing with API post was commented out in original file, keeping it commented or removing?
    // User wants refactor to hook. Original code had commented out API call.
    // I will leave it as is (logging data).
  }

  const onAddChild = () => {
    setState(prev => ({
      ...prev,
      numChildren: prev.numChildren + 1
    }));
  }

  const onRemoveChild = () => {
    if (state.numChildren > 0) {
      setState(prev => ({
        ...prev,
        numChildren: prev.numChildren - 1
      }));
    }
  }

  const children = [];
  for (var i = 0; i < state.numChildren; i += 1) {
    children.push(<ChildComponent key={i} number={i} />);
  };
  const tags_options = [];
  if (state.tags) {
    state.tags.map((item) => (
      tags_options.push({
        value: item,
        label: item.name_en
      })
    ))
  }

  return (
    <div className="col-12">
      {state.error && <p>{state.error.message}</p>}
      {state.success && (
        <Navigate to="/videoindex" replace={true} />
      )}

      <form className="card" onSubmit={handleSubmit}>
        <h4 className="card-title"><strong>Video Information</strong></h4>
        <div className="card-title row">
          <div className="col-md-6">
            <div className="form-group">
              <label className="require" htmlFor="input-required">Title Kh</label>
              <input type="text" className="form-control" id="input-required" name="title_kh" onChange={handleInput} />
            </div>
            <div className="form-group">
              <label className="require" htmlFor="input-required">Description Kh</label>
              <textarea type="text" className="form-control" id="input-required" name="description_kh" onChange={handleInput} />
            </div>

            <div className="form-group">
              <label> Totla price</label>
              <small className="sidetitle">E.g. $ 999.99</small>
              <input type="text" className="form-control" data-format="$ {{999}}.{{99}}" name="total_price" onChange={handleInput} />
            </div>
            <div className="form-group">
              <label>Release_date</label>
              <input className="form-control" type="datetime-local" name="release_date" onChange={handleInput} />
            </div>
          </div>


          <div className="col-md-6">
            <div className="form-group">
              <label>Title En</label>
              <input className="form-control" type="text" name="title_en" onChange={handleInput} />
            </div>
            <div className="form-group">
              <label className="require" htmlFor="input-required">Description En</label>
              <textarea type="text" className="form-control" id="input-required" name="description_en" onChange={handleInput} />
            </div>


            <div className="form-group">
              <label>Discount</label>
              <small className="sidetitle">E.g. %25.46</small>
              <input type="text" className="form-control" data-format="%{{99}}.{{99}}" />
            </div>

            <div className="form-group">
              {/* <label for="inputState" className="col-form-label">Tag</label> */}
              <label>Tag</label>
              <Select
                // defaultValue={[tags_options[2], tags_options[1]]}
                closeMenuOnSelect={false}
                isMulti
                name="options"
                options={tags_options}
                className="basic-multi-select"
                classNamePrefix="select"
                onChange={(value) => {
                  console.log(value)
                  // this.state.selected_tag_id = value.map(v => { return v.value.id })
                  // React state update
                  const ids = value.map(v => v.value.id);
                  setState(prev => ({ ...prev, selected_tag_id: ids }));
                }}
              />
            </div>
            <br />
          </div>
        </div>
        <footer className="card-footer ">
          {/* <div className="card-body row"> */}
          {/* <div className="col-md-6">
                  <div className="text-left">
                      <Link to="#" className="btn btn-danger" onClick={this.onRemoveChild}> Remove <i className="ion-minus-round"></i></Link>
                      <Link to="#" className="btn btn-info" onClick={this.onAddChild}> Add <i className="ion-plus-round"></i></Link>
                  </div>
                </div> */}
          {/* <div className="col-md-6"> */}
          <div className="text-right">
            <Link to="/videoindex" className="btn btn-secondary" >Cancel</Link>
            <button className="btn btn-primary" type="submit" disabled={false}>Save</button>
          </div>
          {/* </div> */}
          {/* </div>     */}
        </footer>
      </form>
      <form className="card">
        <div className="card-body row">
          <div className="col-md-6">
            <div className="form-group">
              <label className="require" htmlFor="input-required">Title en</label>
              <input type="text" className="form-control" id="input-required" name="title_en" onChange={handleInput} />
            </div>
            <div className="form-group">
              <label className="require" htmlFor="input-required">Description en</label>
              <textarea type="text" className="form-control" id="input-required" name="description_en" onChange={handleInput} />
            </div>

            <div className="form-group">
              <label>Price for each episode</label>
              <small className="sidetitle">E.g. $ 999.99</small>
              <input type="text" className="form-control" data-format="$ {{999}}.{{99}}" name="price" onChange={handleInput} />
            </div>
          </div>


          <div className="col-md-6">
            <div className="form-group">
              <label>Title En</label>
              <input className="form-control" type="text" name="title_en" onChange={handleInput} />
            </div>
            <div className="form-group">
              <label className="require" htmlFor="input-required">Description En</label>
              <textarea type="text" className="form-control" id="input-required" name="description_en" onChange={handleInput} />
            </div>
            <div className="form-group">
              <label>Thumbnail</label>
              <div className="input-group file-group">
                <input type="text" className="form-control file-value" placeholder="Choose file..." readOnly />
                <input type="file" multiple onChange={onChangeFile} />
                <span className="input-group-append">
                  <button className="btn btn-light file-browser" type="button"><i className="fa fa-upload"></i></button>
                </span>
              </div>
            </div>
          </div>


          {/* <div className="col-12">
                  <div className="col-md-8">
                      <div className="form-group">
                          <label>Video 720</label>
                          <input type="file" data-provide="dropify" />
                         
                      </div>
                    </div>
                </div> */}


          <div className="card-body row">
            <div className="col-12">
              <div className="form-group">
                <h6 className="mb-1">Episode</h6>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Video 720</label>
                <input type="file" data-provide="dropify" onChange={onChangeFile} />
                <div className="progress">
                  <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{ width: state.percentage + "%" }}></div>
                </div>
                {/* <div style={{textAlign:'center'}}> 
                          <input type="text" value="100" data-provide="knob"></input>
                        </div> */}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Video 1080</label>
                <input type="file" data-provide="dropify" onChange={onChangeFile} />
                <div className="progress">
                  <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{ width: state.percentage + "%" }}></div>
                </div>
                {/* <div style={{textAlign:'center'}}> 
                          <input type="text" value="50" data-provide="knob"></input>
                        </div> */}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Video 4k</label>
                <input type="file" data-provide="dropify" onChange={onChangeFile} />
                <div className="progress">
                  <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{ width: state.percentage + "%" }}></div>
                </div>
                {/* <div style={{textAlign:'center'}}> 
                          <input type="text" value="2" data-provide="knob" data-readonly="true"></input>
                        </div> */}
              </div>
            </div>
          </div>
        </div>
      </form>
      {children}
      <footer className="card-footer ">
        <div className="card-body row">
          <div className="col-md-6">
            <div className="text-left">
              <Link to="#" className="btn btn-danger" onClick={onRemoveChild}> Remove <i className="ion-minus-round"></i></Link>
              <Link to="#" className="btn btn-info" onClick={onAddChild}> Add <i className="ion-plus-round"></i></Link>
            </div>
          </div>
          <div className="col-md-6">
            <div className="text-right">
              <Link to="/videoindex" className="btn btn-secondary" >Cancel</Link>
              <button className="btn btn-primary" type="submit" disabled={false}>Submit</button>
            </div>
          </div>
        </div>
      </footer>
    </div>

  );
}

const ChildComponent = props =>
  <form className="card">
    <div className="card-body row">

      <div className="col-md-6">
        <div className="form-group">
          <label className="require" htmlFor="input-required">Title Kh</label>
          <input type="text" className="form-control" id="input-required" />
        </div>
        <div className="form-group">
          <label className="require" htmlFor="input-required">Description Kh</label>
          <textarea type="text" className="form-control" id="input-required" />
        </div>

        <div className="form-group">
          <label>Price for each episode</label>
          <small className="sidetitle">E.g. $ 999.99</small>
          <input type="text" className="form-control" data-format="$ {{999}}.{{99}}" />
        </div>
      </div>


      <div className="col-md-6">
        <div className="form-group">
          <label>Title En</label>
          <input className="form-control" type="text" />
        </div>
        <div className="form-group">
          <label className="require" htmlFor="input-required">Description En</label>
          <textarea type="text" className="form-control" id="input-required" />
        </div>

        <div className="form-group">
          <label>Thumbnail</label>
          <div className="input-group file-group">
            <input type="text" className="form-control file-value" placeholder="Choose file..." readOnly />
            <input type="file" multiple />
            <span className="input-group-append">
              <button className="btn btn-light file-browser" type="button"><i className="fa fa-upload"></i></button>
            </span>
          </div>
        </div>

        <br />

      </div>


      <div className="card-body row">
        <div className="col-12">
          <div className="form-group">
            <h6 className="mb-1">Episode</h6>
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <label>Video 720</label>
            <input type="file" data-provide="dropify" />
            <div className="progress">
              <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{ width: "0%" }}></div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <label>Video 1080</label>
            <input type="file" data-provide="dropify" />
            <div className="progress">
              <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="55" aria-valuemin="0" aria-valuemax="100" style={{ width: "55%" }}></div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="form-group">
            <label>Video 4k</label>
            <input type="file" data-provide="dropify" />
            <div className="progress">
              <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="15" aria-valuemin="0" aria-valuemax="100" style={{ width: "15%" }}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

export default QuestionsNew;
